import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiPut } from "../../../utils/apiRequests";
import {
  CREATE_SMP_LIST_LOADING,
  CREATE_SMP_LIST_SUCCESS,
  CREATE_SMP_LIST_ERROR,
} from "../../../constant/actionTypes";

export const addSmpPlayersInMatch = (data) => (dispatch) => {
  dispatch({ type: CREATE_SMP_LIST_LOADING });
  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.addMatches}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: CREATE_SMP_LIST_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_SMP_LIST_SUCCESS, response: response });
        dispatch({ type: "CLEAR_SMP_LIST" });
      }
    },
    (error) => {
      dispatch({ type: CREATE_SMP_LIST_ERROR, response: error });
    }
  );
};
